import React from "react";
import { getIn } from "formik";
import SmallTextForm from "./SmallTextForm";
import LargeTextForm from "./LargeTextForm";
import CheckboxForm from "./CheckboxForm";
import DropdownForm from "./DropdownForm";
import RadioForm from "./RadioForm";
import CheckboxListForm from "./CheckboxListForm";

const OrderFormFieldView = ({
  formikProps,
  orderFormField,
  ticket,
  orderFormFieldKey,
}) => {
  const { name, nameForTicket, required, type, options, internalOnly } =
    orderFormField;

  let nameText = ticket && nameForTicket ? nameForTicket : name || "";
  nameText = required ? `${nameText} *` : nameText;
  nameText = internalOnly ? `${nameText} (internal use only)` : nameText;
  const { values, touched, errors, handleChange, handleBlur, setFieldValue } =
    formikProps;
  let value;
  if (values) {
    // value = values[orderFormFieldKey] || "";
    value = getIn(values, orderFormFieldKey) || "";
  } else {
    value = "";
  }
  const orderFormFieldError = getIn(errors, orderFormFieldKey) || "";
  const orderFormFieldTouched = getIn(touched, orderFormFieldKey) || false;

  switch (type) {
    case "smallText":
      return (
        <SmallTextForm
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            nameText,
            value,
            handleChange,
            handleBlur,
          }}
        />
      );
    case "largeText":
      return (
        <LargeTextForm
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            nameText,
            value,
            handleChange,
            handleBlur,
          }}
        />
      );
    case "checkbox":
      return (
        <CheckboxForm
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            nameText,
            value,
            setFieldValue,
            handleBlur,
          }}
        />
      );
    case "multiSelectDropdown":
      return (
        <DropdownForm
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            nameText,
            value,
            options,
            handleChange,
            handleBlur,
          }}
        />
      );
    case "multiSelectRadio":
      return (
        <RadioForm
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            nameText,
            value,
            options,
            handleChange,
            handleBlur,
          }}
        />
      );
    case "multiSelectCheckbox":
      return (
        <CheckboxListForm
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            nameText,
            value,
            options,
            setFieldValue,
            handleBlur,
          }}
        />
      );
    default:
      return null;
  }
};

export default OrderFormFieldView;
